import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Table, Tbody, Tr, Th, Td } from '@/components/elements/Table'
import { ZenkakuSpace } from '@/components/pages/Legal/TextStyle'

export const InfoTable = () => {
  return (
    <Table label="株式基本情報">
      <>
        <InfoTableBody>
          <Tr>
            <Th textAlign="left">決算期</Th>
            <Td textAlign="left">6月30日</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">定時株主総会</Th>
            <Td textAlign="left">9月下旬</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">定時株主総会の株主確定基準日</Th>
            <Td textAlign="left">6月30日</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">配当基準日</Th>
            <Td textAlign="left">
              6月30日。中間配当金の支払いを行う場合は12月31日。
            </Td>
          </Tr>
          <Tr>
            <Th textAlign="left">単元株式数</Th>
            <Td textAlign="left">100株</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">公告方法</Th>
            <Td textAlign="left">
              <p>電子公告</p>
              <p>
                ただし、事故その他のやむを得ない事由によって電子公告による公告をすることができない場合は、官報にて掲載して行います。
              </p>
              <p>
                公告掲載URL：
                <Link href="/" passHref>
                  <StyledLink>https://trial-holdings.inc</StyledLink>
                </Link>
              </p>
            </Td>
          </Tr>
          <Tr>
            <Th textAlign="left">上場取引所</Th>
            <Td textAlign="left">東京証券取引所グロース市場</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">上場日</Th>
            <Td textAlign="left">2024年3月21日</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">証券コード</Th>
            <Td textAlign="left">141A</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">
              <p>株主名簿管理人/</p>
              <p>特別口座の口座管理機関</p>
            </Th>
            <Td textAlign="left">三菱UFJ信託銀行株式会社</Td>
          </Tr>
          <Tr>
            <Th textAlign="left">同連絡先</Th>
            <Td textAlign="left">
              <p>
                三菱UFJ信託銀行株式会社
                <ZenkakuSpace />
                証券代行部
              </p>
              <p>東京都府中市日鋼町1-1</p>
              <p>郵送先：〒137-8081 新東京郵便局私書箱第29号</p>
              <p>TEL：0120-232-711（通話料無料）</p>
            </Td>
          </Tr>
        </InfoTableBody>
      </>
    </Table>
  )
}

const InfoTableBody = styled(Tbody)`
  > tr:first-of-type > th,
  > tr:first-of-type > td {
    border-top: 1px solid ${theme.colors.tableBorder};
  }
`

const StyledLink = styled.a`
  text-decoration: underline;

  &:hover {
    color: ${theme.colors.lightBlue};
  }
`
